<template>
	<div>
		<div class="header-desktop">
			<desktop />
		</div>
		<div class="header-mobile">
			<mobile />
		</div>
	</div>
</template>

<script>
import desktop from "./desktop.vue";
import mobile from "./mobile.vue";
export default {
	components: {desktop, mobile}
};
</script>

<style lang="scss" scoped>
.header-desktop {
	@include res(mobile) {
		display: none;
	}
}
.header-mobile {
	display: none;

	@include res(mobile) {
		display: block;
	}
}
</style>
